var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#232323;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.5,470.1c5.3,0,9.6-4.3,9.6-9.6c0-5.3-4.3-9.6-9.6-9.6h-45.9c-5.3,0-9.6,4.3-9.6,9.6   c0,5.3,4.3,9.6,9.6,9.6H217.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.3,41.9c-5.3,0-9.6,4.3-9.6,9.6s4.3,9.6,9.6,9.6h28.8c5.3,0,9.6-4.3,9.6-9.6s-4.3-9.6-9.6-9.6H179.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.7,133.4H356V40.1c0-21.7-17.6-39.3-39.3-39.3H72.3C50.6,0.7,33,18.4,33,40.1v291.4c0,5.3,4.3,9.6,9.6,9.6   s9.6-4.3,9.6-9.6V95.3h183.4c5.3,0,9.6-4.3,9.6-9.6s-4.3-9.6-9.6-9.6H52.2v-36c0-11.1,9-20.1,20.1-20.1h244.3   c11.1,0,20.1,9,20.1,20.1v36h-41.4c-5.3,0-9.6,4.3-9.6,9.6s4.3,9.6,9.6,9.6h41.4v38.2h-83.6c-21.7,0-39.3,17.6-39.3,39.3v118.8   c0,21.7,17.6,39.3,39.3,39.3h83.6v80.2H151.2c-5.3,0-9.6,4.3-9.6,9.6c0,5.3,4.3,9.6,9.6,9.6h185.6v42.2c0,11.1-9,20.1-20.1,20.1   H72.3c-11.1,0-20.1-9-20.1-20.1v-42.2h41.3c5.3,0,9.6-4.3,9.6-9.6c0-5.3-4.3-9.6-9.6-9.6H52.2v-25.3c0-5.3-4.3-9.6-9.6-9.6   s-9.6,4.3-9.6,9.6v86.7c0,21.7,17.6,39.3,39.3,39.3h244.3c21.7,0,39.3-17.7,39.3-39.3V330.9h83.7c21.7,0,39.3-17.6,39.3-39.3V172.8   C479,151.1,461.4,133.4,439.7,133.4z M459.8,291.6c0,11.1-9,20.1-20.1,20.1H253.1c-11.1,0-20.1-9-20.1-20.1V172.8   c0-1.8,0.3-3.4,0.7-5.1c0.4,0.5,0.9,1,1.4,1.4l106.1,85.2c1.8,1.4,3.9,2.1,6,2.1c2.2,0,4.4-0.8,6.2-2.2l55.6-46.5   c4.1-3.4,4.6-9.5,1.2-13.5c-3.4-4.1-9.5-4.6-13.5-1.2l-49.6,41.5l-100-80.3c-0.2-0.1-0.4-0.2-0.5-0.3c2-0.7,4.2-1.2,6.5-1.2h186.5   c1.7,0,3.2,0.3,4.8,0.6c-0.5,0.3-1,0.6-1.4,1l-22.8,19.1c-4.1,3.4-4.6,9.5-1.2,13.5c1.9,2.3,4.6,3.4,7.4,3.4c2.2,0,4.4-0.7,6.2-2.2   l22.8-19.1c1.4-1.1,2.3-2.6,2.8-4.1c1,2.4,1.6,5.1,1.6,7.9V291.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.7ffe217e078b30d4042eb3425d415ce8.svg";
export { ForwardRef as ReactComponent };